import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { ActionPresentation } from '../Action/ActionPresentation.js';
import { DwindlePresentation } from '../Dwindle/DwindlePresentation.js';
import { IconPresentation } from '../Icon/IconPresentation.js';
import { hostClass } from './ActionButton.styles.js';

var defaultProps = {
  look: "primary",
  disabled: false,
  onClick: function onClick() {
    /* empty */
  },
  actionRef: function actionRef() {
    /* empty */
  },
  onMouseHoverChange: function onMouseHoverChange() {
    /* empty */
  },
  onKeyboardFocusChange: function onKeyboardFocusChange() {
    /* empty */
  }
};
var ActionButtonPresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2;

  var id = props.id,
      className = props.className,
      children = props.children,
      icon = props.icon,
      iconName = props.iconName,
      iconVariant = props.iconVariant,
      name = props.name,
      look = props.look,
      disabled = props.disabled,
      onClick = props.onClick,
      htmlAttrs = props.htmlAttrs,
      noMargin = props.noMargin,
      href = props.href,
      actionRef = props.actionRef,
      hasMouseHover = props.hasMouseHover,
      onMouseHoverChange = props.onMouseHoverChange,
      hasKeyboardFocus = props.hasKeyboardFocus,
      onKeyboardFocusChange = props.onKeyboardFocusChange,
      clicked = props.clicked,
      floating = props.floating,
      isStencilHost = props.isStencilHost;
  var iconColor = disabled && "disabled" || look === "secondary" && "default" || "anthracite";
  return /*#__PURE__*/React.createElement(Host, {
    isStencilHost: isStencilHost,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, className, className), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__floating"), floating), _cleanupClassObject))
  }, /*#__PURE__*/React.createElement(ActionPresentation, {
    id: id,
    htmlAttrs: htmlAttrs,
    disabled: disabled,
    href: href,
    name: name,
    ref: actionRef,
    onClick: onClick,
    onMouseHoverChange: onMouseHoverChange,
    onKeyboardFocusChange: onKeyboardFocusChange
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-wrapper-inner"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-wrapper-inner__disabled"), disabled), _cleanupClassObject2))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-dwindle-wrapper")
  }, /*#__PURE__*/React.createElement(DwindlePresentation, {
    look: look,
    disabled: disabled,
    shape: "circle",
    floating: floating,
    hover: hasMouseHover || hasKeyboardFocus,
    clicked: clicked
  }, /*#__PURE__*/React.createElement(IconPresentation, {
    noMargin: true,
    icon: icon,
    name: iconName,
    color: iconColor,
    variant: iconVariant,
    size: "small",
    "aria-hidden": true,
    title: ""
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-label")
  }, children))));
}, defaultProps);

export { ActionButtonPresentation, defaultProps };
